module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('section', {
    staticClass: "latests"
  }, [_c('div', {
    staticClass: "latestHeading"
  }, [_c('h4', {
    staticClass: "latestTitle"
  }, [_vm._v(_vm._s(_vm.renderText(_vm.container.label.ja, _vm.container.label.en)))])]), _vm._l((_vm.container.content), function(post) {
    return (_vm.container.content != null) ? _c('postLink', {
      attrs: {
        "post": post,
        "projectName": _vm.projectName,
        "isNew": true
      }
    }) : _vm._e()
  }), _c('router-link', {
    staticClass: "toPosts readmore",
    attrs: {
      "to": _vm.toPosts(_vm.container.slug)
    }
  }, [(_vm.projectNo < 4) ? _c('span', [_vm._v("0" + _vm._s(_vm.projectNo))]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.renderText(_vm.container.label.ja + ' 一覧へ', 'READ MORE')))])]), (_vm.container.content == null) ? _c('spinner') : _vm._e()], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f6a99406!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/about/latest.vue
// module id = 112
// module chunks = 1